import { NextPage } from 'next';

import { LocaleTypes } from '@i18n';

import auth from '@config/auth.json';
import { generateRoute } from '@utils/router';

import { rolesEnum } from '@HOCs/WithRole';
import getDataFromTokenPayload from '@utils/tokenManipulation/getDataFromTokenPayload';
import getRefreshToken from '@utils/tokenManipulation/getRefreshToken';

const IS_DEV = process.env.NODE_ENV === 'development';

interface IBaseWithRole {
    locale: LocaleTypes;
    Component: { roles?: rolesEnum } & NextPage;
    props: Record<string, unknown>;
}

const BaseWithRole: React.FC<IBaseWithRole> = ({ locale, Component, props }) => {
    const roles = Component?.roles;
    const refreshToken = getRefreshToken();

    const userRole: string = getDataFromTokenPayload('user_role');

    // Если пользователь неавторизован
    if (roles) {
        if (typeof window !== 'undefined' && !refreshToken && !roles.includes(rolesEnum.guest)) {
            window.location.href = IS_DEV ? 'auth' : generateRoute(auth.AUTH_URL, { locale });
        } else if (
            typeof window !== 'undefined' &&
            refreshToken &&
            userRole &&
            !roles.includes(userRole)
        ) {
            window.location.href = `/${locale}/dashboard`;
        }
    }

    return <Component {...props} />;
};

export default BaseWithRole;
